const OTP = {
  OTP_LENGTH:  6  ,
  RESEND_SECS: 59 ,
} as const;

export default OTP;